import { Box, Container, Grid, Paper, Typography, useMediaQuery } from '@material-ui/core';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { makeStyles } from '@material-ui/styles';
import Banner from '../../components/Banner/Banner';

const useStyles = makeStyles({
  primary: {

    marginTop: "50px",
    fontWeight: 'bold'
  },
  secondary: {
    marginTop: "5px"
  }
})

function Impressum() {
  const { t, } = useTranslation();
  const classes = useStyles()
  const matches = useMediaQuery('(min-width:900px)');

  document.title = t('Title.main') + " | " + t('Title.subTitle.impressum')

  return (
    <React.Fragment>
      <Paper>
        <Box
          className='main'
          minHeight='80vh'
          sx={{
            background: 'white',
            // background: 'linear-gradient(114deg, rgba(255,255,255,0.5) 0%, rgba(110,171,220,0.5) 52%, rgba(97,181,183,0.5) 64%, rgba(242,143,97,0.5) 100%)',
            // minHeight: '100vh',
            py: 10
          }}>

          <Grid
            container>

            <Banner background='#546e7a' marginBottom={0} style={{ height: '10vh' }} >
              <Grid
                item
                xl={12}
                lg={12}
                md={12}
                sm={12}
                xs={12}
                display='flex'
                alignItems='center'
                marginBottom={0}>
                <Container>
                  <Typography variant='h3' textAlign={matches ? 'left' : 'center'} fontWeight='bold' color='white'>Birds of Paradise Kft.</Typography>
                </Container>
              </Grid>
            </Banner>
          </Grid>
          <Container>
            <Grid
              container
              display='flex'
              justifyContent='space-between'
            >
              <Grid
                item
                xl={6}
                lg={6}
                md={6}
                sm={12}
                xs={12}
              >
                <Typography className={classes.primary} style={{ marginTop: '65px' }}>
                  Székhely <Typography className={classes.secondary}> 1015 Budapest, Batthyány utca 48. 4. em. 7.</Typography>
                </Typography>
                <Typography className={classes.primary} style={{ marginTop: '25px' }}>
                  Cégjegyzékszám <Typography className={classes.secondary}>0109-376675</Typography>
                </Typography>
                <Typography className={classes.primary} style={{ marginTop: '25px' }}>
                  Adószám <Typography className={classes.secondary}> 28846839-2-41</Typography>
                </Typography>
                <Typography className={classes.primary} style={{ marginTop: '25px' }}>
                  E-mail <Typography className={classes.secondary}> info@birdsofparadise.hu</Typography>
                </Typography>
                <Typography className={classes.primary} style={{ marginTop: '25px' }}>
                  Kamarai tagság <Typography className={classes.secondary}> Budapesti Kereskedelmi és Iparkamara</Typography>
                </Typography>
                <Typography className={classes.primary} style={{ marginTop: '25px' }}>
                  Számlavezető bank
                </Typography>
                <ul style={{ listStyleType: 'none' }}>
                  <li style={{ listStyleType: 'none' }}><Typography className={classes.secondary}>OTP Bank Nyrt.</Typography></li>
                  {/* <ul style={{listStyleType: 'none'}}> */}
                  <li style={{ listStyleType: 'none' }}><Typography className={classes.secondary}>SWIFT (BIC):OTPVHUHB</Typography></li>
                  <li style={{ listStyleType: 'none' }}><Typography className={classes.secondary}>IBAN (HUF):HU05 1170 2012 2145 1528 0000 0000</Typography></li>
                  {/* <li style={{ listStyleType: 'none' }}><Typography className={classes.secondary}>Lorem Ipsum</Typography></li> */}
                  {/* </ul> */}
                </ul>
              </Grid>
            </Grid>
          </Container>
        </Box>
      </Paper>
    </React.Fragment>
  )
}

export default Impressum
